var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWorries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .001h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 10.001)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#365E7D",
    cx: 21.171,
    cy: 21.171,
    r: 21.171
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.086 21.171C43.086 9.48 33.422 0 21.5 0c-.485 0-.966.017-1.444.048 10.745.697 19.34 9.104 20.087 19.633.05.715-.547 1.307-1.278 1.292a16.42 16.42 0 0 0-.337-.004c-8.902 0-16.119 7.079-16.119 15.81 0 .82.064 1.626.187 2.412.243 1.554-.908 2.995-2.507 3.101l-.033.003c.478.03.959.048 1.444.048 11.991 0 21.585-9.557 21.585-21.172z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F4FBFF",
    cx: 21.543,
    cy: 20.8,
    r: 16.343
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.886 20.8c0-9.026-7.388-16.343-16.501-16.343-.447 0-.89.018-1.328.053 8.524.672 15.223 7.76 15.173 16.386h-.001c-6.963 1.357-12.156 7.106-12.858 13.967a2.471 2.471 0 0 1-2.314 2.227c9.608.758 17.829-6.74 17.829-16.29z",
    fill: "#DAF1F4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#365E7D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.543 9.34a.782.782 0 0 1-.787-.777v-1.1c0-.43.352-.777.787-.777.434 0 .786.348.786.777v1.1c0 .43-.352.777-.786.777zM30.18 12.878a.789.789 0 0 1-.556-.228.772.772 0 0 1 0-1.1l.787-.777a.793.793 0 0 1 1.112 0 .772.772 0 0 1 0 1.1l-.786.777a.789.789 0 0 1-.556.228zM34.87 21.418h-1.112a.782.782 0 0 1-.786-.778c0-.43.352-.778.786-.778h1.113c.434 0 .786.349.786.778 0 .43-.352.778-.787.778zM21.866 34.914a.782.782 0 0 1-.786-.777v-1.1c0-.43.352-.778.786-.778.435 0 .787.349.787.778v1.1c0 .43-.352.777-.787.777zM12.119 30.735a.79.79 0 0 1-.557-.228.772.772 0 0 1 0-1.1l.787-.777a.793.793 0 0 1 1.112 0 .772.772 0 0 1 0 1.1l-.786.777a.79.79 0 0 1-.556.228zM9.327 21.418H8.215a.782.782 0 0 1-.786-.778c0-.43.352-.778.786-.778h1.112c.435 0 .787.349.787.778 0 .43-.352.778-.787.778zM12.905 12.878a.789.789 0 0 1-.556-.228l-.786-.777a.772.772 0 0 1 0-1.1.793.793 0 0 1 1.112 0l.786.777a.772.772 0 0 1 0 1.1.789.789 0 0 1-.556.228z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.478 22.286a.824.824 0 0 1-.564-.22l-2.841-2.664a.757.757 0 0 1-.015-1.1.83.83 0 0 1 1.142-.014l1.47 1.377V14.15c0-.43.362-.778.808-.778.446 0 .808.349.808.778v7.359a.778.778 0 0 1-.494.717.834.834 0 0 1-.314.06z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DC0020",
    cx: 38.629,
    cy: 36.4,
    r: 13.371
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.676 23.029c-.518 0-1.03.03-1.533.088 6.636.764 11.79 6.419 11.79 13.283s-5.154 12.52-11.79 13.283c.503.058 1.015.088 1.533.088C46.035 49.771 52 43.785 52 36.4c0-7.385-5.965-13.371-13.324-13.371z",
    fill: "#AB0019"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F4FBFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.886 39.99c-.82 0-1.486-.702-1.486-1.568v-9.367c0-.867.665-1.57 1.486-1.57.82 0 1.485.703 1.485 1.57v9.367c0 .866-.665 1.569-1.485 1.569zM37.886 46.057c-.82 0-1.486-.702-1.486-1.569v-1c0-.866.665-1.568 1.486-1.568.82 0 1.485.702 1.485 1.569v1c0 .866-.665 1.568-1.485 1.568z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#DAF1F4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.886 27.486c-.271 0-.525.078-.743.211.443.272.743.777.743 1.358v9.367c0 .58-.3 1.086-.743 1.357.219.134.472.212.743.212.82 0 1.485-.703 1.485-1.57v-9.366c0-.867-.665-1.57-1.485-1.57zM37.886 41.92c-.271 0-.525.078-.743.211.443.272.743.777.743 1.358v1c0 .58-.3 1.085-.743 1.357.219.133.472.211.743.211.82 0 1.485-.702 1.485-1.569v-1c0-.866-.665-1.568-1.485-1.568z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWorries);
export default __webpack_public_path__ + "static/media/noWorries.da3904b5.svg";
export { ForwardRef as ReactComponent };